export enum Direction {
  Left = -1,
  Right = 1,
}
